export const canReceiveStripeTransfers = ({ stripeTransfersEnabled } = {}) =>
  stripeTransfersEnabled === true;

export const getStripeTransferBlockedMessage = ({
  stripeDisabledReason,
  stripeRequirementsDue,
} = {}) => {
  const requirementCount = Array.isArray(stripeRequirementsDue)
    ? stripeRequirementsDue.length
    : 0;

  if (requirementCount > 0) {
    const itemLabel = requirementCount === 1 ? 'item' : 'items';
    return `Stripe requires ${requirementCount} additional onboarding ${itemLabel} before transfers can be enabled.`;
  }

  if (stripeDisabledReason) {
    return 'Stripe has paused transfers until the account requirements are resolved.';
  }

  return 'Stripe has not confirmed that this account can receive transfers yet.';
};
